'use client';

import { ReactNode, useRef } from 'react';
import { styled } from '@linaria/react';
import Button from '@fe-common-ui/Button';
import useFolder from '@fe-news/hooks/use-folder';

const QuoteContainer = styled.div<{ isFold?: boolean }>`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  max-height: ${({ isFold }) => (isFold ? '122px' : '100%')};
  overflow: hidden;
`;

const FolderContainer = ({ children }: { children?: ReactNode }) => {
  const quotesReference = useRef<HTMLDivElement | null>(null);
  const { isExpand, setIsExpand, order } = useFolder(quotesReference);

  const onClick = () => setIsExpand(v => !v);
  return (
    <QuoteContainer ref={quotesReference} isFold={!isExpand}>
      {children}
      <Button.Folder theme='' active={isExpand} onClick={onClick} order={order} hide={order === -1} />
    </QuoteContainer>
  );
};

export default FolderContainer;
